import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  p.MuiTypography-body1 {
    text-transform: uppercase;

    font-weight: bold;
    font-size: 1.2rem;

    color: #3f51b5;
  }

  > div:not(:first-child) {
    margin-top: 2rem;
  }

  > fieldset {
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 4px;

    margin-top: 2rem;
    padding: 1rem;

    display: flex;
    flex-direction: column;

    > div:not(:first-child),
    > fieldset {
      margin-top: 2rem;
    }

    .__legend {
      text-transform: uppercase;

      font-weight: bold;
      font-size: 1.2rem;

      color: #3f51b5;

      padding: 0 1rem;
    }
  }
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 2rem;

  > fieldset {
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 4px;

    padding: 1rem;

    display: flex;
    flex-direction: column;

    > div:not(:first-child) {
      margin-top: 1rem;
    }

    > div:last-child {
      margin-top: 20px;
      margin-bottom: 10px;
    }


    .__legend {
      text-transform: uppercase;

      font-weight: bold;
      font-size: 1.2rem;

      color: #3f51b5;

      padding: 0 1rem;
    }

  }
`;

export const infoWrapper = styled.div`
  display:flex;
  justify-content:end;
`


export const iconWrapper = styled.div`

  max-width:100px;


`;
